import {
  List, Edit, Create, SimpleForm, TextInput, NumberInput, required,
} from 'react-admin';
import { Stack } from '@mui/material';
import HandshakeIcon from '@mui/icons-material/Handshake';
import { ImageUploadInput } from '../../components/ImageUploadInput.jsx';
import { ReorderableDatagrid, imageCell } from '../../components/ReorderableDatagrid.jsx';

const PartnerList = () => (
  <List sort={{ field: 'sortOrder', order: 'ASC' }} perPage={100} pagination={false} empty={false}>
    <ReorderableDatagrid
      columns={[
        { key: 'logo', header: 'Logo', width: 100, render: (r) => imageCell(r.logo, r.name) },
        { key: 'name', header: 'Name', render: (r) => r.name },
      ]}
    />
  </List>
);

const PartnerForm = () => (
  <Stack spacing={2} sx={{ maxWidth: 520 }}>
    <TextInput source="name" validate={required()} fullWidth />
    <ImageUploadInput source="logo" label="Logo image" />
    <TextInput
      source="url"
      label="Website link (optional)"
      fullWidth
      helperText='Full URL, e.g. "https://www.cambridgeinternational.org". Clicking the logo opens this in a new tab.'
    />
    <NumberInput source="sortOrder" defaultValue={0} />
  </Stack>
);

const PartnerEdit = () => (
  <Edit redirect="list" mutationMode="pessimistic">
    <SimpleForm><PartnerForm /></SimpleForm>
  </Edit>
);
const PartnerCreate = () => (
  <Create redirect="list">
    <SimpleForm><PartnerForm /></SimpleForm>
  </Create>
);

export default {
  list: PartnerList,
  edit: PartnerEdit,
  create: PartnerCreate,
  icon: HandshakeIcon,
  options: { label: 'Partners' },
  recordRepresentation: 'name',
};
